import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';

import styles from './StudentCourseDetailsFooter.module.scss';
import usePresenter from './StudentCourseDetailsFooter.presenter';
import getProps from './StudentCourseDetailsFooter.props';
import { StudentCourseDetailsFooterCombinedProps } from './types';


const StudentCourseDetailsFooter: React.FC<StudentCourseDetailsFooterCombinedProps> = (props) => {
  const {
    className,
    classes,
    divider,
    text,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.studentCourseDetailsFooter;

  return (
    <div className={cx(currentStyle, className)}>
      <Divider
        className={cx(styles.divider, classes?.divider)}
        {...internalProps.divider}
        {...divider}/>
      <div className={cx(styles.content, classes?.content)}>
        <Text
          className={cx(styles.text, classes?.text)}
          {...internalProps.text}
          {...text}/>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
      </div>
    </div>
  );
};

export default StudentCourseDetailsFooter;

